import { ClasseInfo } from '../classe/classe.def';
import { ROLE } from '../../helpers/user/authorization';
import { ID, NOTE } from '../typeDef';
import { ProfileInfo } from './user.def';
import { AvatarMedia } from '../avatar/avatarList.def';

export interface CSVEleveTypes {
  Prenom: string;
  Nom: string;
}

export interface CSVEleveResultsTypes {
  data: CSVEleveTypes[];
  error: any[];
  meta: Record<string, unknown>;
}

export interface EleveProfil {
  firstname: string;
  lastname: string;
  email: string;
  classe?: ClasseInfo;
}

export interface AddEleveTypes {
  email?: string;
  tel?: string;
  firstname: string;
  lastname: string;
}
export interface EleveInputTypes extends AddEleveTypes {
  username: string;
  password: string;
  classes: string;
  confirmed: boolean;
  role?: string;
}

interface ErrorElFieldsTypes {
  firstname: string | boolean;
  lastname: string | boolean;
}

interface AddEleveFormTypes {
  values: EleveInputTypes;
  errors: ErrorElFieldsTypes;
  isValid: boolean;
}

export const eleveSchema: AddEleveFormTypes = {
  values: {
    username: null,
    email: null,
    tel: null,
    firstname: null,
    lastname: null,
    password: null,
    classes: null,
    confirmed: true
  },
  errors: {
    lastname: true,
    firstname: true
  },
  isValid: false
};

export interface AccountSidbarUser {
  avatar: AvatarMedia;
  firstname: string;
  lastname: string;
  role: ROLE;
  lycee: {
    name?: string;
    ville?: string;
  };
}

export interface EleveLeaderBoard extends ProfileInfo {
  elId: ID;
  moyennegenerale: NOTE;
  rank: number | (1 | 2 | 3);
}
